import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";

function Shell({ title, children, testid }) {
  return (
    <div className="min-h-screen bg-[#0f1c17] text-white flex items-center justify-center p-5" data-testid={testid}>
      <div className="w-full max-w-sm space-y-4">
        <div className="text-emerald-300 text-xs uppercase tracking-[0.2em]">Playmaker</div>
        <h1 className="text-2xl font-semibold">{title}</h1>
        {children}
        <Link to="/login" className="block text-xs text-white/60 hover:text-white" data-testid="auth-back-login">← Terug naar inloggen / Back to sign in</Link>
      </div>
    </div>
  );
}
const input = "w-full h-12 rounded-xl bg-white/10 border border-white/15 px-4 text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-emerald-400";
const btn = "w-full h-12 rounded-xl bg-emerald-500 text-[#0f1c17] font-semibold disabled:opacity-60";

export function ForgotPassword() {
  const [email, setEmail] = useState(""); const [msg, setMsg] = useState(""); const [busy, setBusy] = useState(false);
  const submit = async (e) => { e.preventDefault(); setBusy(true); try { await api.post("/auth/forgot-password", { email }); setMsg("Als dit e-mailadres bekend is, is er een resetlink verstuurd. / If this e-mail exists, a reset link has been sent."); } catch (err) { setMsg(formatApiErrorDetail(err?.response?.data?.detail)); } finally { setBusy(false); } };
  return (
    <Shell title="Wachtwoord vergeten" testid="forgot-password-page">
      <form onSubmit={submit} className="space-y-3">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-mailadres" className={input} data-testid="forgot-email" />
        <button type="submit" disabled={busy} className={btn} data-testid="forgot-submit">Stuur resetlink / Send reset link</button>
        {msg && <div className="text-sm text-emerald-200" data-testid="forgot-msg">{msg}</div>}
      </form>
    </Shell>
  );
}

export function ResetPassword() {
  const { token } = useParams(); const navigate = useNavigate();
  const [pw, setPw] = useState(""); const [pw2, setPw2] = useState(""); const [msg, setMsg] = useState(""); const [busy, setBusy] = useState(false);
  const submit = async (e) => { e.preventDefault(); if (pw !== pw2) { setMsg("Wachtwoorden komen niet overeen / Passwords do not match"); return; } setBusy(true); try { await api.post("/auth/reset-password", { token, password: pw }); setMsg("Gelukt! Je kunt nu inloggen. / Done! You can sign in now."); setTimeout(() => navigate("/login"), 1500); } catch (err) { setMsg(formatApiErrorDetail(err?.response?.data?.detail)); } finally { setBusy(false); } };
  return (
    <Shell title="Nieuw wachtwoord" testid="reset-password-page">
      <form onSubmit={submit} className="space-y-3">
        <input type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Nieuw wachtwoord (min. 8)" className={input} data-testid="reset-password" />
        <input type="password" minLength={8} required value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Herhaal wachtwoord" className={input} data-testid="reset-password2" />
        <button type="submit" disabled={busy} className={btn} data-testid="reset-submit">Opslaan / Save</button>
        {msg && <div className="text-sm text-emerald-200" data-testid="reset-msg">{msg}</div>}
      </form>
    </Shell>
  );
}

export function VerifyEmail() {
  const { token } = useParams(); const [msg, setMsg] = useState("Bezig… / Verifying…");
  useEffect(() => { api.post(`/auth/verify-email/${token}`).then(() => setMsg("E-mailadres bevestigd ✓ / E-mail verified ✓")).catch((e) => setMsg(formatApiErrorDetail(e?.response?.data?.detail))); }, [token]);
  return <Shell title="E-mail bevestigen" testid="verify-email-page"><div className="text-sm text-emerald-200" data-testid="verify-msg">{msg}</div></Shell>;
}
